var map = {
	"./1-cts.webp": 87457,
	"./11-Hewlett-Packard.svg": 74058,
	"./12-tvs.webp": 22724,
	"./13-Tech_Mahindra.webp": 54091,
	"./14-Britannia.webp": 1507,
	"./16-Bosch.webp": 81864,
	"./17-Polaris.webp": 61632,
	"./18-Soliton.webp": 16511,
	"./19-Hyundai.webp": 52260,
	"./20-sanmar.webp": 95684,
	"./21-LarsenToubro.webp": 39469,
	"./22-hatsun.webp": 2269,
	"./23-Vedanta.webp": 31456,
	"./25-Payoda.webp": 71527,
	"./25-nissan.webp": 73675,
	"./26-sirius.webp": 79649,
	"./27-Vernalis.webp": 97609,
	"./29-anristu.webp": 358,
	"./3-infosys.webp": 29698,
	"./30-kalycito.webp": 69791,
	"./31-fanuc.webp": 82145,
	"./31-odessa.webp": 53135,
	"./31-urc.svg": 18292,
	"./34-vuram.webp": 8372,
	"./35-rane.webp": 2228,
	"./36-sakthi.webp": 20575,
	"./38-delphi.webp": 94337,
	"./39-kbr.webp": 43985,
	"./4-accenture.webp": 29102,
	"./40-airlight.webp": 87252,
	"./41-Trimble.webp": 31742,
	"./42-pentafox.webp": 511,
	"./43-josh.webp": 72203,
	"./44-Rapid_Data.webp": 3295,
	"./45-blubridge.webp": 57411,
	"./46-valeo.webp": 35641,
	"./47-Bi3-Logo.webp": 74557,
	"./48-CDW Sirius.webp": 42089,
	"./49-codemagen_logo.webp": 39486,
	"./5-zoho.webp": 20377,
	"./50-jman.webp": 99717,
	"./51.Securin.svg": 82776,
	"./52-Likan.webp": 98552,
	"./53-Rubrik.webp": 46657,
	"./6-Huawei-Logo.webp": 92363,
	"./7-newge.webp": 25637,
	"./8-Mu-sigma.webp": 35778,
	"./9-ELGi.webp": 20038,
	"./BIO_FOOD_CHEM/accura_deldrods.webp": 20426,
	"./BIO_FOOD_CHEM/amul.webp": 14516,
	"./BIO_FOOD_CHEM/angel_starch_food_pvt_ltd.webp": 19197,
	"./BIO_FOOD_CHEM/april3rdfoods.webp": 19953,
	"./BIO_FOOD_CHEM/britannia_rfid.webp": 91965,
	"./BIO_FOOD_CHEM/freezeton.webp": 62097,
	"./BIO_FOOD_CHEM/green_collar_agritech_solutions.webp": 98022,
	"./BIO_FOOD_CHEM/grenera_nutrents_pvt_ltd.webp": 15333,
	"./BIO_FOOD_CHEM/itc_food_division.webp": 83378,
	"./BIO_FOOD_CHEM/jain_resource_recycling.webp": 33215,
	"./BIO_FOOD_CHEM/primas_bioscience.webp": 33676,
	"./BIO_FOOD_CHEM/reading_chocolate__sago_factory__.webp": 85399,
	"./BIO_FOOD_CHEM/sahuwala_flour_mills.webp": 31592,
	"./BIO_FOOD_CHEM/sid_s_farm.webp": 42752,
	"./BIO_FOOD_CHEM/skm_egg_products.webp": 1675,
	"./BIO_FOOD_CHEM/vintage_agro.webp": 20671,
	"./CIVIL_CORE/bull_machine.webp": 74476,
	"./CIVIL_CORE/gea_bgr___group.webp": 14748,
	"./CIVIL_CORE/greenmile_consultancy_services_pvt_ltd.webp": 55442,
	"./CIVIL_CORE/hr_construction.webp": 80487,
	"./CIVIL_CORE/jain_resource_recycling.webp": 90195,
	"./CIVIL_CORE/janaki_construction.webp": 4597,
	"./CIVIL_CORE/jindal_steel.webp": 75989,
	"./CIVIL_CORE/jsw.webp": 84545,
	"./CIVIL_CORE/kanchi_karpooram_limited.webp": 72273,
	"./CIVIL_CORE/nimir_construction.webp": 54922,
	"./CIVIL_CORE/pmel_pvt__ltd.webp": 76626,
	"./CIVIL_CORE/ramalingan_construction.webp": 60773,
	"./CIVIL_CORE/ramco_cements_ltd.webp": 89514,
	"./CIVIL_CORE/reliance_industries.webp": 54189,
	"./CIVIL_CORE/spic.webp": 70144,
	"./CIVIL_CORE/src_projects.webp": 70478,
	"./CIVIL_CORE/sri_venkatachalapathy_construction_private_limited.webp": 30810,
	"./CIVIL_CORE/synapse_robotics.webp": 49418,
	"./CIVIL_CORE/timbertruss_design_private_limited.webp": 20067,
	"./CSE_IT/accenture.webp": 25485,
	"./CSE_IT/addis_it_solutions.webp": 47833,
	"./CSE_IT/appsentinels.webp": 46711,
	"./CSE_IT/avasoft.webp": 11939,
	"./CSE_IT/aypols.webp": 2869,
	"./CSE_IT/besant_technologies.webp": 53247,
	"./CSE_IT/bhawan_cybertex.webp": 76345,
	"./CSE_IT/bigboon_technologies.webp": 98876,
	"./CSE_IT/blubridge_technologies.webp": 60468,
	"./CSE_IT/calibraint_technologies.webp": 35711,
	"./CSE_IT/capgemini.webp": 9170,
	"./CSE_IT/cartrabbit_technologies.webp": 70540,
	"./CSE_IT/codemagon.webp": 45152,
	"./CSE_IT/codingmart.webp": 98365,
	"./CSE_IT/cognizant.webp": 54632,
	"./CSE_IT/crescent_moon_solutions.webp": 56975,
	"./CSE_IT/deloitte.webp": 83651,
	"./CSE_IT/edspark.webp": 92339,
	"./CSE_IT/endava_solution.webp": 31396,
	"./CSE_IT/enthu_technology.webp": 60186,
	"./CSE_IT/erp_roots.webp": 63274,
	"./CSE_IT/gecatech.webp": 72279,
	"./CSE_IT/genworx_ai.webp": 89438,
	"./CSE_IT/greenvision_technologies.webp": 6086,
	"./CSE_IT/hcl_tech.webp": 88319,
	"./CSE_IT/i6_tech_labs.webp": 64126,
	"./CSE_IT/iamneo.webp": 92942,
	"./CSE_IT/ibm.webp": 77591,
	"./CSE_IT/ignitarium.webp": 65078,
	"./CSE_IT/imagitive_technology.webp": 76233,
	"./CSE_IT/infosys.webp": 48728,
	"./CSE_IT/integra_connect.webp": 94540,
	"./CSE_IT/jman_group.webp": 93233,
	"./CSE_IT/josh.webp": 77155,
	"./CSE_IT/jp_morganchase.webp": 32552,
	"./CSE_IT/kaar_technologies.webp": 77103,
	"./CSE_IT/kently.webp": 1734,
	"./CSE_IT/kurium_io.webp": 52689,
	"./CSE_IT/leumasware.webp": 12979,
	"./CSE_IT/likan_cleancell_innovations_pvt_ltd.webp": 65233,
	"./CSE_IT/mallow.webp": 10315,
	"./CSE_IT/mavenly.webp": 37665,
	"./CSE_IT/mithilai.webp": 57654,
	"./CSE_IT/mr_cooper.webp": 35331,
	"./CSE_IT/nexont.webp": 19805,
	"./CSE_IT/pentafox.webp": 99518,
	"./CSE_IT/pinnacle_infotech.webp": 58032,
	"./CSE_IT/platform_science.webp": 89937,
	"./CSE_IT/presidio.webp": 38952,
	"./CSE_IT/qspiders.webp": 80392,
	"./CSE_IT/rabbitqr.webp": 76604,
	"./CSE_IT/real_tech_system.webp": 32744,
	"./CSE_IT/rently.webp": 64859,
	"./CSE_IT/rinex.webp": 44029,
	"./CSE_IT/robotai_technologies.webp": 3998,
	"./CSE_IT/rubrix.webp": 98035,
	"./CSE_IT/securin.webp": 41004,
	"./CSE_IT/simaxtech.webp": 39375,
	"./CSE_IT/sirius.webp": 62550,
	"./CSE_IT/sketch_brahma.webp": 17947,
	"./CSE_IT/smartdv.webp": 85658,
	"./CSE_IT/soliton.webp": 76059,
	"./CSE_IT/srinsoft.webp": 12465,
	"./CSE_IT/survay_sparrow.webp": 83190,
	"./CSE_IT/tap_academy.webp": 28089,
	"./CSE_IT/tcs.webp": 70895,
	"./CSE_IT/trellisys.webp": 33684,
	"./CSE_IT/unilogic_technologies.webp": 20454,
	"./CSE_IT/vintorix_webberax_solutions_.webp": 53313,
	"./CSE_IT/virtusa.webp": 92103,
	"./CSE_IT/visai_labs.webp": 94522,
	"./CSE_IT/vtiger.webp": 78758,
	"./CSE_IT/winfomi.webp": 27962,
	"./CSE_IT/workhall.webp": 62681,
	"./CSE_IT/xoriant.webp": 13304,
	"./CSE_IT/zettaone_technologies.webp": 26230,
	"./CSE_IT/zoho.webp": 28777,
	"./CSE_IT/zuci_systems.webp": 27471,
	"./Core Engineering/25-Payoda.webp": 16250,
	"./Core Engineering/25-nissan.webp": 61558,
	"./Core Engineering/26-sirius.webp": 21212,
	"./Core Engineering/27-Vernalis.webp": 14828,
	"./Core Engineering/29-anristu.webp": 49966,
	"./Core Engineering/30-kalycito.webp": 62026,
	"./Core Engineering/31-fanuc.webp": 72818,
	"./Core Engineering/31-odessa.webp": 28730,
	"./Core Engineering/31-urc.svg": 11629,
	"./Core Engineering/34-vuram.webp": 95867,
	"./Core Engineering/35-rane.webp": 97029,
	"./Core Engineering/36-sakthi.webp": 47686,
	"./Core Engineering/38-delphi.webp": 784,
	"./Core Engineering/39-kbr.webp": 5294,
	"./Core Engineering/40-airlight.webp": 19385,
	"./Core Engineering/41-Trimble.webp": 1397,
	"./Core Engineering/42-pentafox.webp": 58542,
	"./Core Engineering/43-josh.webp": 63226,
	"./Core Engineering/44-Rapid_Data.webp": 6214,
	"./Core Engineering/brakesindia.webp": 68609,
	"./EEE_ECE/applied_materials.webp": 93685,
	"./EEE_ECE/base_automation.webp": 32528,
	"./EEE_ECE/caliber_interconnect.webp": 42442,
	"./EEE_ECE/careyu_automation.webp": 68086,
	"./EEE_ECE/core_el.webp": 99360,
	"./EEE_ECE/crp_robots.webp": 1282,
	"./EEE_ECE/data_pattern.webp": 2014,
	"./EEE_ECE/delphi_tvs.webp": 83523,
	"./EEE_ECE/delta.webp": 23543,
	"./EEE_ECE/flow_control_commune_pvt_ltd_.webp": 55455,
	"./EEE_ECE/jse.webp": 8147,
	"./EEE_ECE/kitron_india_services_pvt_ltd.webp": 94843,
	"./EEE_ECE/krishna_power_technologies.webp": 90364,
	"./EEE_ECE/kt_telematics.webp": 44606,
	"./EEE_ECE/lakshmi_electrical_control_systems_ltd.webp": 87103,
	"./EEE_ECE/linkra_cables.webp": 36045,
	"./EEE_ECE/logicgo_infotech.webp": 55258,
	"./EEE_ECE/netgear.webp": 66409,
	"./EEE_ECE/niral_automation.webp": 40441,
	"./EEE_ECE/nsk_bearings.webp": 26141,
	"./EEE_ECE/one_assist_technologies.webp": 24100,
	"./EEE_ECE/radiant_global_technology.webp": 58715,
	"./EEE_ECE/robovision_pvt_ltd.webp": 64637,
	"./EEE_ECE/schneider.webp": 97996,
	"./EEE_ECE/silex_technologies.webp": 20643,
	"./EEE_ECE/system_controls.webp": 15729,
	"./EEE_ECE/tessolve_semiconductors.webp": 92677,
	"./EEE_ECE/toshiba.webp": 49433,
	"./EEE_ECE/trimble.webp": 88196,
	"./EEE_ECE/valeo_india_pvt_ltd.webp": 82760,
	"./EEE_ECE/yokogawa.webp": 15045,
	"./Endava Solutions logo.webp": 14279,
	"./Green Collar Agritech Solutions Pvt. Ltd. Logo.webp": 83035,
	"./IT & Software/1-cts.webp": 53246,
	"./IT & Software/12-tvs.webp": 49185,
	"./IT & Software/13-Tech_Mahindra.webp": 39310,
	"./IT & Software/14-Britannia.webp": 51766,
	"./IT & Software/17-Polaris.webp": 30965,
	"./IT & Software/18-Soliton.png": 75762,
	"./IT & Software/18-Soliton.webp": 46570,
	"./IT & Software/19-Hyundai.webp": 98921,
	"./IT & Software/20-sanmar.webp": 50859,
	"./IT & Software/21-LarsenToubro.webp": 48314,
	"./IT & Software/22-hatsun.webp": 9654,
	"./IT & Software/23-Vedanta.webp": 28125,
	"./IT & Software/3-infosys.webp": 28141,
	"./IT & Software/4-accenture.webp": 48489,
	"./IT & Software/5-zoho.webp": 65932,
	"./IT & Software/6-Huawei-Logo.webp": 75536,
	"./IT & Software/7-newge.webp": 14926,
	"./IT & Software/8-Mu-sigma.webp": 34335,
	"./IT & Software/9-ELGi.webp": 37079,
	"./IT & Software/bosch.webp": 2979,
	"./IT & Software/icici.webp": 30187,
	"./IT & Software/itc.webp": 6870,
	"./IT & Software/tcs.webp": 14358,
	"./IT & Software/wipro.webp": 35943,
	"./IamNeo.ai logo.webp": 19351,
	"./Ignitarium logo.webp": 947,
	"./J&F India Pvt. Ltd..webp": 61916,
	"./JPMorgan Chase (1).webp": 17307,
	"./MECH_AUTO/adrasti.webp": 67223,
	"./MECH_AUTO/adwik_intellimech__mds.webp": 41454,
	"./MECH_AUTO/aquasub.webp": 87043,
	"./MECH_AUTO/barry_wehmiller.webp": 56487,
	"./MECH_AUTO/brakes_india.webp": 26495,
	"./MECH_AUTO/craftsman__automation__limited.webp": 59791,
	"./MECH_AUTO/dcw.webp": 61211,
	"./MECH_AUTO/emerson.webp": 46122,
	"./MECH_AUTO/freezeton.webp": 37601,
	"./MECH_AUTO/griffyn_robotech.webp": 31119,
	"./MECH_AUTO/h_mv_engineering.webp": 27054,
	"./MECH_AUTO/harvee_designs.webp": 11734,
	"./MECH_AUTO/hitech_calibration.webp": 23347,
	"./MECH_AUTO/janatics.webp": 56378,
	"./MECH_AUTO/jgc.webp": 82773,
	"./MECH_AUTO/kavin_engineering_and_services_pvt_ltd.webp": 38709,
	"./MECH_AUTO/krisam_automation.webp": 58758,
	"./MECH_AUTO/kuka_india_pvt_ltd.webp": 31637,
	"./MECH_AUTO/kyb.webp": 88871,
	"./MECH_AUTO/l_g_balakrishnan___bros__limited.webp": 72533,
	"./MECH_AUTO/madhu_jayanthi_international.webp": 25348,
	"./MECH_AUTO/manis_powertech_engineer.webp": 81837,
	"./MECH_AUTO/mcwane.webp": 48954,
	"./MECH_AUTO/motherson_smrc.webp": 70025,
	"./MECH_AUTO/namic_industrial_solution.webp": 17389,
	"./MECH_AUTO/pallavaa_group___tgt_role.webp": 11616,
	"./MECH_AUTO/pothigai_power_solutions.webp": 6481,
	"./MECH_AUTO/propel_industries.webp": 90934,
	"./MECH_AUTO/real_tech_system.webp": 83024,
	"./MECH_AUTO/sakthi_auto_components_ltd.webp": 19507,
	"./MECH_AUTO/slb.webp": 16602,
	"./MECH_AUTO/sublime_structures.webp": 26537,
	"./MECH_AUTO/tac_tuticorin.webp": 95349,
	"./MECH_AUTO/titan_engineering_and_automation_limited.webp": 79972,
	"./MECH_AUTO/tvs_sri_chakra.webp": 80776,
	"./MECH_AUTO/weg_industries.webp": 17855,
	"./MECH_AUTO/wtt_international_pvt__ltd.webp": 18440,
	"./Management/45-blubridge.webp": 9245,
	"./Management/46-valeo.webp": 17535,
	"./Management/47-Bi3-Logo.webp": 24179,
	"./Management/48-CDW Sirius.webp": 31467,
	"./Management/49-codemagen_logo.webp": 56940,
	"./Management/50-jman.webp": 21571,
	"./Management/51.Securin.svg": 90726,
	"./Management/52-Likan.webp": 33070,
	"./Management/53-Rubrik.webp": 59,
	"./Management/Endava Solutions logo.webp": 3245,
	"./Management/Green Collar Agritech Solutions Pvt. Ltd. Logo.webp": 97013,
	"./Management/IamNeo.ai logo.webp": 78177,
	"./Management/Ignitarium logo.webp": 5713,
	"./Management/J&F India Pvt. Ltd..webp": 40630,
	"./Management/JPMorgan Chase (1).webp": 99329,
	"./Management/Presidio_logo.webp": 61954,
	"./Management/Radiant global technology logo.webp": 55616,
	"./Management/adrasti_logo.webp": 11835,
	"./Management/coreelteh.webp": 43958,
	"./Management/erproots.webp": 48797,
	"./Management/hitech calibration logo.webp": 73931,
	"./Management/nbase2 logo (1).webp": 11901,
	"./Management/openmynz.webp": 98733,
	"./Management/schneider.webp": 51272,
	"./Presidio_logo.webp": 59864,
	"./Radiant global technology logo.webp": 43170,
	"./SKM Groups logo.webp": 3633,
	"./SRC Projects.webp": 42397,
	"./Startups/SKM Groups logo.webp": 99950,
	"./Startups/SRC Projects.webp": 57036,
	"./Startups/WhatsApp Image 2025-09-15 at 11.27.31 AM.webp": 76143,
	"./Startups/WhatsApp Image 2025-09-15 at 11.28.18 AM.webp": 37237,
	"./Startups/WhatsApp Image 2025-09-15 at 11.35.49 AM.webp": 82861,
	"./Startups/WhatsApp Image 2025-09-15 at 11.45.14 AM.webp": 19884,
	"./Startups/WhatsApp Image 2025-09-15 at 11.45.57 AM.webp": 44251,
	"./Startups/WhatsApp Image 2025-09-15 at 11.55.18 AM.webp": 17041,
	"./Startups/WhatsApp Image 2025-09-16 at 1.43.24 PM.webp": 16984,
	"./Startups/WhatsApp Image 2025-09-16 at 1.43.48 PM.webp": 23610,
	"./Startups/WhatsApp Image 2025-09-16 at 2.21.06 PM.webp": 81615,
	"./Startups/WhatsApp Image 2025-10-09 at 11.26.43 AM.webp": 88710,
	"./Startups/WhatsApp Image 2025-10-09 at 11.42.54 AM.webp": 12148,
	"./Startups/workhall logo.webp": 60353,
	"./WhatsApp Image 2025-09-15 at 11.27.31 AM.webp": 9538,
	"./WhatsApp Image 2025-09-15 at 11.28.18 AM.webp": 28028,
	"./WhatsApp Image 2025-09-15 at 11.35.49 AM.webp": 5980,
	"./WhatsApp Image 2025-09-15 at 11.45.14 AM.webp": 27065,
	"./WhatsApp Image 2025-09-15 at 11.45.57 AM.webp": 74598,
	"./WhatsApp Image 2025-09-15 at 11.55.18 AM.webp": 34708,
	"./WhatsApp Image 2025-09-16 at 1.43.24 PM.webp": 10367,
	"./WhatsApp Image 2025-09-16 at 1.43.48 PM.webp": 99209,
	"./WhatsApp Image 2025-09-16 at 2.21.06 PM.webp": 30536,
	"./WhatsApp Image 2025-10-09 at 11.26.43 AM.webp": 97007,
	"./WhatsApp Image 2025-10-09 at 11.42.54 AM.webp": 98801,
	"./adrasti_logo.webp": 82857,
	"./bosch.webp": 25972,
	"./brakesindia.webp": 98792,
	"./coreelteh.webp": 79028,
	"./erproots.webp": 78919,
	"./hitech calibration logo.webp": 33473,
	"./icici.webp": 77652,
	"./itc.webp": 9597,
	"./nbase2 logo (1).webp": 68195,
	"./openmynz.webp": 28227,
	"./schneider.webp": 666,
	"./tcs.webp": 95437,
	"./wipro.webp": 33256,
	"./workhall logo.webp": 78858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57296;